import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import JugadoresPage from "./pages/JugadoresPage";
import JugadorDetallePage from "./pages/JugadorDetallePage";
import WellnessDashboardPage from "./pages/WellnessDashboardPage";
import PagosPage from "./pages/PagosPage";
import CategoriasPage from "./pages/CategoriasPage";
import CategoriaDetallePage from "./pages/CategoriaDetallePage";
import TorneosPage from "./pages/TorneosPage";
import TorneoDetallePage from "./pages/TorneoDetallePage";
import StaffPage from "./pages/StaffPage";
import SettingsPage from "./pages/SettingsPage";
import AuditoriaPage from "./pages/AuditoriaPage";
import PagoOnlinePage from "./pages/PagoOnlinePage";
import PagoResultadoPage from "./pages/PagoResultadoPage";

const qc = new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: 30000 } } });

function ProtectedRoute({ children, adminOnly }: { children: React.ReactNode; adminOnly?: boolean }) {
  const { isAuthenticated, isAdmin } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (adminOnly && !isAdmin()) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/dashboard"    element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/jugadores"    element={<ProtectedRoute><JugadoresPage /></ProtectedRoute>} />
      <Route path="/jugadores/:id" element={<ProtectedRoute><JugadorDetallePage /></ProtectedRoute>} />
      <Route path="/wellness"     element={<ProtectedRoute><WellnessDashboardPage /></ProtectedRoute>} />
      <Route path="/pagos"        element={<ProtectedRoute><PagosPage /></ProtectedRoute>} />
      <Route path="/categorias"       element={<ProtectedRoute><CategoriasPage /></ProtectedRoute>} />
      <Route path="/categorias/:id"   element={<ProtectedRoute><CategoriaDetallePage /></ProtectedRoute>} />
      <Route path="/torneos"          element={<ProtectedRoute><TorneosPage /></ProtectedRoute>} />
      <Route path="/torneos/:id"      element={<ProtectedRoute><TorneoDetallePage /></ProtectedRoute>} />
      <Route path="/staff"            element={<ProtectedRoute adminOnly><StaffPage /></ProtectedRoute>} />
      <Route path="/auditoria"        element={<ProtectedRoute adminOnly><AuditoriaPage /></ProtectedRoute>} />
      <Route path="/pago-online"       element={<ProtectedRoute><PagoOnlinePage /></ProtectedRoute>} />
      <Route path="/pago-resultado"    element={<ProtectedRoute><PagoResultadoPage /></ProtectedRoute>} />
      <Route path="/settings"         element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <QueryClientProvider client={qc}>
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
